module.exports = __webpack_public_path__ + "static/img/chanta (17).d62d898.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (17).jpg
// module id = lvCT
// module chunks = 0